import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { SiteField } from '@/@vxapp/@Enums/PHP/ServicesV2/Sites/Enums/SiteField'
import { SiteProjectionField } from '@/@vxapp/@Enums/PHP/ServicesV2/Sites/Enums/SiteProjectionField'

export const SitesTableHeaders = [
  { title: '#ID', align: 'start', key: 'id', placeholder: '00000' },
  { title: 'Domain', align: 'start', key: SiteField.DOMAIN, placeholder: 'example.com' },
  { title: 'Type', align: 'start', key: SiteField.SITE_TYPE, sortable: false },
  { title: 'Status', align: 'start', key: SiteField.STATUS, sortable: false },
  { title: 'Contact', align: 'start', key: SiteField.CONTACT_EMAIL, sortable: false },
  { title: 'URL', align: 'start', key: SiteProjectionField.WEB_URL, sortable: false },
  { title: 'Actions', align: 'end', key: 'actions', sortable: false },
] as const satisfies readonly TableHeaderSpec[]
